import React from 'react';

const BulkDiscountCategoryModal = ({ show, onClose, value, onChange, discountCategories = [], selectedCount, onApply, loading, message }) => {
  if (!show) return null;
  return (
    <>
      <div className="modal-backdrop show" style={{ zIndex: 1040 }} />
      <div
        className="modal show"
        tabIndex="-1"
        role="dialog"
        style={{ display: 'block', zIndex: 1050 }}
        onClick={() => !loading && onClose()}
      >
        <div className="modal-dialog modal-dialog-centered" role="document" onClick={e => e.stopPropagation()}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Встановити категорію знижки</h5>
              <button type="button" className="close" aria-label="Close" onClick={() => !loading && onClose()}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body text-left">
              <select
                id="bulkDiscountCategory"
                className="form-control"
                value={value}
                onChange={e => onChange(e.target.value)}
              >
                <option value="">—</option>
                {discountCategories.map(name => (
                  <option key={name} value={name}>{name}</option>
                ))}
              </select>
              <p className="text-muted small mt-2 mb-0 text-left">
                Буде застосовано до {selectedCount} обраних товарів.
              </p>
              {message && (
                <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-danger'} mt-3 mb-0`} role="alert">
                  {message.text}
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-dark btn-block"
                onClick={onApply}
                disabled={loading || !value}
              >
                {loading ? 'Застосування…' : 'Застосувати'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BulkDiscountCategoryModal;
